import { useEffect, useState } from 'react'
import { getDevChromeEngine, setDevChromeEngine } from '../api'
import { IS_BOOSTER_ONLY, IS_PROFILER_ONLY } from '../product'

// DEV-only Chrome engine picker (147 / 152 / 156 / …), shown at the bottom of the
// sidebar. Renders NOTHING unless the backend reports availability (BB_INTERNAL dev
// panel AND at least one override binary present on disk) — so it never appears on
// client panels. The button list is DRIVEN BY THE BACKEND (`engines`): a new version
// appears automatically once its binary exists on the box (one map entry in server.py).
// Switching affects only NEW worker launches; the default (147) build is never touched.
export default function DevEngineSwitcher({ collapsed }: { collapsed?: boolean }) {
  const [avail, setAvail] = useState(false)
  const [engine, setEngine] = useState<string>('147')
  const [engines, setEngines] = useState<string[]>(['147'])
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (IS_BOOSTER_ONLY || IS_PROFILER_ONLY) return
    getDevChromeEngine()
      .then((r) => {
        if (r && r.available) {
          setAvail(true)
          const list = Array.isArray(r.engines) && r.engines.length ? r.engines : ['147']
          setEngines(list)
          setEngine(list.includes(r.engine) ? r.engine : '147')
        }
      })
      .catch(() => {})
  }, [])

  if (collapsed || !avail) return null

  const pick = async (e: string) => {
    if (busy || e === engine) return
    const prev = engine
    setBusy(true)
    setEngine(e)
    try {
      const r = await setDevChromeEngine(e)
      if (r && r.error) setEngine(prev)
    } catch {
      setEngine(prev)
    } finally {
      setBusy(false)
    }
  }

  // самая свежая версия (кроме 147) помечается ·new
  const newest = engines.reduce((a, b) => (parseInt(b, 10) > parseInt(a, 10) ? b : a), '0')

  return (
    <div className="px-4 py-2 border-t border-sidebar-border">
      <div className="text-[10px] uppercase tracking-wider text-amber-500/70 font-semibold mb-1">
        DEV · движок Chrome
      </div>
      <div className="flex gap-1 flex-wrap">
        {engines.map((e) => (
          <button
            key={e}
            disabled={busy}
            onClick={() => pick(e)}
            title={e === '147' ? 'Рабочая сборка Chromium 147' : `Сборка Chromium ${e} (тест)`}
            className={`flex-1 min-w-[52px] h-7 rounded text-xs font-medium transition-colors disabled:opacity-60 ${
              engine === e
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted'
            }`}
          >
            {e !== '147' && e === newest ? `${e} ·new` : e}
          </button>
        ))}
      </div>
      <div className="text-[10px] text-muted-foreground/50 mt-1">действует на новые запуски потоков</div>
    </div>
  )
}
